var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              attrs: {
                model: _vm.queryForm.params,
                "label-position": "top",
                size: "small",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "align-items": "flex-end" },
                  attrs: { gutter: 10, justify: "left", type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "customerManagements.customerChannel"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              on: { "visible-change": _vm.getChannelData },
                              model: {
                                value: _vm.queryForm.params.customerChannelList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerChannelList",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.customerChannelList",
                              },
                            },
                            _vm._l(_vm.channelList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.value, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("customerManagements.clientID"),
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("collectionCenter.inputNum"),
                              clearable: "",
                              maxlength: "6",
                              "show-word-limit": "",
                            },
                            on: { input: _vm.idInput },
                            model: {
                              value: _vm.queryForm.params.id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "id",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryForm.params.id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "CNPJ" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseEnterTheContent"
                              ),
                              clearable: "",
                              size: "small",
                            },
                            on: { input: _vm.changeCnpjMother },
                            model: {
                              value: _vm.queryForm.params.cnpjMother,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "cnpjMother",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryForm.params.cnpjMother",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("customerManagements.AccountName"),
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseEnterTheContent"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "username", $$v)
                              },
                              expression: "queryForm.params.username",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { width: "auto", "margin-bottom": "18px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-search",
                            size: "small",
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getData(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("operationCenter.Procurar")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh", size: "small" },
                          on: { click: _vm.queryFormReset },
                        },
                        [_vm._v(_vm._s(_vm.$t("operationCenter.reset")) + " ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "advanced_btn",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("operationCenter.advancedSearch")) +
                              " "
                          ),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-caret-top"
                              : "el-icon-caret-bottom",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShow,
                      expression: "isShow",
                    },
                  ],
                  staticStyle: { "align-items": "flex-end" },
                  attrs: { gutter: 10, justify: "left", type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("customerManagements.CompanyName"),
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseEnterTheContent"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "company", $$v)
                              },
                              expression: "queryForm.params.company",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("collectionCenter.dot") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.siteId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "siteId", $$v)
                                },
                                expression: "queryForm.params.siteId",
                              },
                            },
                            _vm._l(_vm.siteIdList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("customerManagements.AccountStatus"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.lockState,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "lockState",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.lockState",
                              },
                            },
                            [
                              _c("el-option", {
                                key: 1,
                                attrs: {
                                  label: _vm.$t("customerManagements.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                key: 2,
                                attrs: {
                                  label: _vm.$t("customerManagements.enable"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                key: 3,
                                attrs: {
                                  label: _vm.$t("customerManagements.Disable"),
                                  value: 1,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("customerManagements.ApprovalStatus"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.auditState,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "auditState",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.auditState",
                              },
                            },
                            [
                              _c("el-option", {
                                key: 1,
                                attrs: {
                                  label: _vm.$t("customerManagements.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                key: 2,
                                attrs: {
                                  label: _vm.$t("customerManagements.NotAudit"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                key: 3,
                                attrs: {
                                  label: _vm.$t("customerManagements.approved"),
                                  value: 1,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "flx-between",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:customer-managements:list:add",
                          expression: "'btn:customer-managements:list:add'",
                          arg: "remove",
                        },
                      ],
                      attrs: {
                        icon: "el-icon-plus",
                        size: "mini",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goPage({}, _vm.typeObj.add.code)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("customerManagements.addCustomer")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:customer-managements:list:export",
                          expression: "'btn:customer-managements:list:export'",
                          arg: "remove",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.exportTableData()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.export")) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value:
                            "btn:customer-managements:list:invitationRegistration",
                          expression:
                            "'btn:customer-managements:list:invitationRegistration'",
                          arg: "remove",
                        },
                      ],
                      attrs: { size: "mini", type: "warning" },
                      on: { click: _vm.showRegisterDialog },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("login.invitationRegistration")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { staticClass: "tree_box", attrs: { span: 3 } }, [
                _c("div", { staticClass: "tree_title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerManagements.accountHierarchyTree"))
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "tree-scroll" },
                  [
                    _c("el-tree", {
                      staticClass: "my-tree",
                      attrs: {
                        data: _vm.dataTree,
                        "highlight-current": true,
                        props: _vm.defaultProps,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var node = ref.node
                            var data = ref.data
                            return _c(
                              "div",
                              {
                                staticClass: "custom-tree-node ellipsis",
                                staticStyle: { width: "100px" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ellipsis span-label",
                                    class: {
                                      "custom-origan-tree-node":
                                        data["children"] &&
                                        data["children"].length,
                                    },
                                    attrs: { title: node.label },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onClickNode(node.data)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(node.label) + " ")]
                                ),
                              ]
                            )
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-col",
                { attrs: { span: 21 } },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "customer-table",
                      attrs: {
                        data: _vm.tableData,
                        "header-cell-style": {
                          background: "#f2f2f2",
                          color: "black",
                        },
                        height: 540,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.clientID"),
                          prop: "id",
                          width: "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.AccountName"),
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.username
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "bottom-start",
                                              "popper-class": "copy",
                                              trigger: "hover",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  color: "black",
                                                  "font-size": "15px",
                                                  padding: "5px !important",
                                                },
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copy(
                                                      scope.row.username
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("orderDetails.copy")
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-click-column sleTwo",
                                                attrs: { slot: "reference" },
                                                slot: "reference",
                                              },
                                              [
                                                scope.row.username.length > 29
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          content:
                                                            scope.row.username,
                                                          effect: "dark",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "is-click-column sleTwo",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.goPage(
                                                                  scope.row,
                                                                  _vm.typeObj
                                                                    .examine
                                                                    .code,
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  scope.row
                                                                    .username
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "is-click-column sleTwo",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.goPage(
                                                              scope.row,
                                                              _vm.typeObj
                                                                .examine.code,
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row.username
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.AccountNickname"),
                          "show-overflow-tooltip": true,
                          prop: "customerAlias",
                          width: "160",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.CompanyName"),
                          "show-overflow-tooltip": true,
                          prop: "company",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom-start",
                                      "popper-class": "copy",
                                      trigger: "hover",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          color: "black",
                                          "font-size": "15px",
                                          padding: "5px !important",
                                        },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copy(scope.row.company)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("orderDetails.copy")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [_vm._v(_vm._s(scope.row.company))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("trajectory.TaxID"),
                          "show-overflow-tooltip": true,
                          prop: "cnpjMother",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("encryption-field", {
                                  attrs: {
                                    "encrypted-value": scope.row.cnpjMother,
                                    label: _vm.$t("trajectory.TaxID"),
                                    "field-name": "cnpjMother",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.customerType"),
                          align: "center",
                          prop: "coPrincipalName",
                          width: "130",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.source === "corporation"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "customerManagements.enterprise"
                                          )
                                        ) + " "
                                      ),
                                    ])
                                  : scope.row.source === "person"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.personal"
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    )
                                  : _c("span", [_vm._v("/")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.channels"),
                          align: "center",
                          prop: "channel",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.customerQuote"),
                          align: "center",
                          prop: "hasQuote",
                          width: "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.hasQuote === true
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("GlobalSetObj.yes"))
                                      ),
                                    ])
                                  : scope.row.hasQuote === false
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.$t("GlobalSetObj.No"))),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.quoteStatus"),
                          align: "center",
                          prop: "quoteStatus",
                          width: "120",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.quoteStatus === 3
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.disableQuote"
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    )
                                  : scope.row.quoteStatus === 2
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "warning" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.unusedQuote"
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    )
                                  : scope.row.quoteStatus === 1
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.inUseQuote"
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    )
                                  : scope.row.quoteStatus === 0
                                  ? _c("el-tag", { attrs: { type: "info" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "customerManagements.expiredQuote"
                                          )
                                        ) + " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.isCteInvoiced"),
                          align: "center",
                          prop: "isCteInvoiced",
                          width: "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.ApprovalStatus"),
                          align: "center",
                          prop: "coPrincipalName",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.auditState === 0
                                  ? _c("el-tag", { attrs: { type: "info" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("customerManagements.NotAudit")
                                        ) + " "
                                      ),
                                    ])
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.approved"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.AccountStatus"),
                          align: "center",
                          prop: "coPrincipalName",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.lockState === 0
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("customerManagements.enable")
                                          ) + " "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.Disable"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("userManage.site"),
                          prop: "siteName",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("login.creationMethod"),
                          prop: "createMethodName",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("login.inviter"),
                          prop: "inviterUserName",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.authInfo"),
                          prop: "authList",
                          width: "180",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.authList && scope.row.authList.length
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        scope.row.authList,
                                        function (item, index) {
                                          return _c("div", { key: index }, [
                                            _c("div", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customerManagements.authStatus"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.authStatus === 0
                                                      ? _vm.$t(
                                                          "customerManagements.authStatusUnauthorized"
                                                        )
                                                      : item.authStatus === 1
                                                      ? _vm.$t(
                                                          "customerManagements.authStatusAuthorizing"
                                                        )
                                                      : _vm.$t(
                                                          "customerManagements.authStatusExpired"
                                                        )
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customerManagements.platformName"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(_vm._s(item.platform)),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customerManagements.remainingDays"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(item.remainingDays)
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customerManagements.authTime"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(_vm._s(item.authTime)),
                                              ]),
                                            ]),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "customerManagements.noAuthInfo"
                                          )
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("userManage.creator"),
                          prop: "createName",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("CenterForSorting.CreationTime"),
                          prop: "createTime",
                          width: "160",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.createSiteName"),
                          prop: "createSiteName",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("CenterForSorting.ModifiedBy"),
                          prop: "updateName",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("CenterForSorting.ModificationTime"),
                          prop: "updateTime",
                          width: "160",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerManagements.updateSiteName"),
                          prop: "updateSiteName",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("operationCenter.operate"),
                          fixed: "right",
                          width: "155",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom-start",
                                      trigger: "click",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                          gap: "8px",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permit",
                                                rawName: "v-permit:remove",
                                                value:
                                                  "btn:customer-managements:list:edit",
                                                expression:
                                                  "'btn:customer-managements:list:edit'",
                                                arg: "remove",
                                              },
                                            ],
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.goPage(
                                                  scope.row,
                                                  _vm.typeObj.edit.code,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("operationCenter.Edit")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "permit",
                                                rawName: "v-permit:remove",
                                                value:
                                                  "btn:customer-managements:list:audit",
                                                expression:
                                                  "'btn:customer-managements:list:audit'",
                                                arg: "remove",
                                              },
                                            ],
                                            staticClass: "fl",
                                          },
                                          [
                                            scope.row.auditState === 0
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "warning",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.accountReview(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "customerManagements.Approval"
                                                        )
                                                      ) + " "
                                                    ),
                                                  ]
                                                )
                                              : [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "permit",
                                                          rawName:
                                                            "v-permit:remove",
                                                          value:
                                                            "btn:customer-managements:list:lock",
                                                          expression:
                                                            "'btn:customer-managements:list:lock'",
                                                          arg: "remove",
                                                        },
                                                      ],
                                                    },
                                                    [
                                                      scope.row.lockState === 1
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                size: "mini",
                                                                type: "warning",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.accountStatus(
                                                                      scope.row,
                                                                      0
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ChannelManage.enable"
                                                                  )
                                                                ) + " "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                size: "mini",
                                                                type: "danger",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.accountStatus(
                                                                      scope.row,
                                                                      1
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "ChannelManage.Disable"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permit",
                                                rawName: "v-permit:remove",
                                                value:
                                                  "btn:customer-managements:list:reset-pwd",
                                                expression:
                                                  "'btn:customer-managements:list:reset-pwd'",
                                                arg: "remove",
                                              },
                                            ],
                                            attrs: {
                                              size: "mini",
                                              type: "danger",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleResetPwd(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "customerManagements.resetPassword"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          size: "mini",
                                        },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "operationCenter.MoreActions"
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "pagination" },
                    [
                      _c("el-pagination", {
                        staticStyle: { margin: "6px 0 0" },
                        attrs: {
                          "current-page": _vm.queryForm.pageNumber,
                          "page-size": _vm.queryForm.pageSize,
                          "page-sizes": [10, 20, 50, 100],
                          total: _vm.total,
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageNumber", $event)
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageNumber", $event)
                          },
                          "update:pageSize": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageSize", $event)
                          },
                          "update:page-size": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageSize", $event)
                          },
                          "current-change": function ($event) {
                            _vm.getData((_vm.find = 0))
                          },
                          "size-change": function ($event) {
                            _vm.getData((_vm.find = 0))
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerObj.title,
            visible: _vm.drawerObjVisible,
            "wrapper-closable": true,
            direction: "ltr",
            size: "65%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerObjVisible = $event
            },
            close: _vm.closeDrawer,
          },
        },
        [
          _vm.drawerObjVisible
            ? _c("tab-cmp", {
                ref: "tabCmps",
                attrs: {
                  "currency-obj": _vm.currencyObj,
                  "customer-type": _vm.drawerObj.customerType,
                  "send-arr": _vm.sendArr,
                },
                on: {
                  resetPwd: _vm.handleResetPwd,
                  updataData: _vm.updataData,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": true,
            title: _vm.$t("customerManagements.resetPassword"),
            visible: _vm.resetPwdObj.visible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.resetPwdObj, "visible", $event)
            },
          },
        },
        [
          _vm.resetPwdObj.visible
            ? _c("reset-pwd-cmp", {
                attrs: { ids: _vm.resetPwdObj.ids },
                on: {
                  handleCancel: function ($event) {
                    _vm.resetPwdObj.visible = false
                  },
                  handleDetermine: _vm.handleDetermine,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title:
              _vm.rechargeType === 1
                ? "充值金额"
                : _vm.$t("customerManagements.ModifyCreditLimit"),
            visible: _vm.showType,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showType = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "recharge",
                  staticClass: "queryFormClass",
                  attrs: {
                    model: _vm.recharge,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _vm.rechargeType === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "充值金额:", prop: "rechargeAmount" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "customerManagements.pleaseInput"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.recharge.rechargeAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.recharge, "rechargeAmount", $$v)
                              },
                              expression: "recharge.rechargeAmount",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.rechargeType === 2
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("customerManagements.creditsL"),
                            prop: "creditLimit",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "customerManagements.pleaseInput"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.recharge.creditLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.recharge, "creditLimit", $$v)
                              },
                              expression: "recharge.creditLimit",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "info" },
                  on: {
                    click: function ($event) {
                      return _vm.updataAmount(0)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("customerManagements.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updataAmount(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("customerManagements.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("InviteToRegister", { ref: "InviteToRegisterRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }